/*globals Stripe*/

// show labels
$('body').on('focus', '.fields li input, .fields li textarea', function() {
	var $this = $(this);
	$this.keyup(function() {
		if($this.val() !== '') {
			$this.parent('li').addClass('filled').removeClass('error');
		} else {
			$this.parent('li').removeClass('filled');
		}
	});
});

$('body').on('blur', '.fields li input, .fields li textarea', function() {
    var $this = $(this);
    if($this.val() !== '') {
        $this.parent('li').addClass('filled').removeClass('error');
    } else {
        $this.parent('li').removeClass('filled');
    }
});

// submitting the pay form
$('body').on('submit', '.pay form', function() {
    // var fields = $(this).serializeArray();
    var $this = $(this);
    var error = false;

    $('.pay .required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        $('.pay-error [data-input="message"]').html('Please fill out all required fields');
        openModal('.pay-error');
        return false;
    }

    loading('Processing...');
    // create the stripe token
    Stripe.setPublishableKey($('body').attr('data-stripe'));
    Stripe.card.createToken({
        name: $('.pay input[name="first_name"]').val()+' '+$('.pay input[name="last_name"]').val(),
        number: $('.pay input[name="card_number"]').val(),
        cvc: $('.pay input[name="cvv"]').val(),
        exp_month: $('.pay input[name="expiry_month"]').val(),
        exp_year: $('.pay input[name="expiry_year"]').val(),
        address_line1: $('.pay input[name="street"]').val(),
        address_state: $('.pay input[name="state"]').val(),
        address_zip: $('.pay input[name="zip"]').val()
    }, function(status, response) {
        if(response.error) {
            $('.pay-error [data-input="message"]').html(response.error.message);
            openModal('.pay-error');
            unloading();
            error = true;
            return false;
        }

        var payload = {};
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.stripe_token = response.id;
        payload.first_name = $('.pay input[name="first_name"]').val();
        payload.last_name = $('.pay input[name="last_name"]').val();
        payload.street = $('.pay input[name="street"]').val();
        payload.state = $('.pay input[name="state"]').val();
        payload.zip = $('.pay input[name="zip"]').val();
        payload.email = $('.pay input[name="email"]').val();
        payload.phone = $('.pay input[name="phone"]').val();
        payload.amount = $('.pay input[name="amount"]').val();
        payload.brand = response.card.brand;
        payload.last_four = response.card.last4;
        payload.month = $('.pay input[name="expiry_month"]').val();
        payload.year = $('.pay input[name="expiry_year"]').val();
        payload.message = $('.pay textarea[name="message"]').val();
        console.log(payload);

        loading('Processing...');
        $.ajax({
            type : 'POST',
            url : $this.attr('action'),
            data : payload,
            dataType : 'json',
            success : function(data) {
                unloading();
                // console.log(data);
                if(data.success) {
                    $('.pay-thank-you [data-input="message"]').html(data.message);
                    $('.pay-thank-you [data-input="password"]').html(data.password);
                    openModal('.pay-thank-you');
                } else {
                    $('.pay-error [data-input="message"]').html(data.message);
                    openModal('.pay-error');
                }
            },
            error : function(request) {
                console.log(request.responseText);
            }
        });

        return false;
    });

    return false;
});